webpackJsonp([35783957827783],{

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(121);
	var isArguments = __webpack_require__(120);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(86)))

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(55)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(134);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(119);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(131);
	
	var _HelmetConstants = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(13);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(89);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(57);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(91);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(55);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(87);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(90);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(89);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(57);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(91);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(55);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(87);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(90);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(89);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(57);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(91);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(391);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(55);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(87);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(90);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(388);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(389);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(390);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(394);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(132);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(57);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(393);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(132);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(122);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(136);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M1365.237 268.592l-.237 1.404 3-.824-1.64-1.172zM1312.348 238.146l-2.41.573-.926.23-.006-.009-17.253 4.106-.753 21.824 16.82-3.957.324-.079 33.233-8.205 1.376-.345.003.006 1.4 4.85 1.256-.075.74 3.706 6.755 2.65 1.585 3.579.4-.052 2.879-1.427 5.571-5.68 3.188-.225 1.818 2.848 1.107-.14 5-3.468 2.574-.376.971-1.018-1.367.782-10.904-1.27-3.337-4.769-2.51-1.036-1.987-4.963-1.767-1.188-4.836-.933-1.491-1.397-.336-3.42.892-2.715 1.189-.918.623-4.166 1.222-1.106-5.623-6.363-1.2.094-7.805 7.46-.59.145-25.843 6.426zM909.745 496.205l.009.894 1.13 2.418-1.11-.227.053 5.066L907 512l29.828-1.95-1.468-6.606 8.832.145.572 1.07 32.949-2.694 1.255-1.41.003-.006.51-.048 77.336-8.03.021-.003 13.832-3.958 1.392-3.68 4.839-2.267.128-2.81 3.288-2.356-.103-2.72 15.786-14.71-1.796-.14-1.645-2.303-3.513-1.301-1.121-3.273-5.496-5.255.125-1.691-5.623-5.709 1.705-3.668-.917-4.776-1.076-1.144-2.006-2.137-3.909-1.036-2.158-4.697-1.48.637-2.793 3.93-5.015 1.598-5.994-3.052-1.44.643-.915 2.394-4.185-.607-3.878-3.554-9.52-.73-3.312-6.762-3.204-2.222-4.155 1.754-3.054-1.866-1.909 1.697 1.56 2.107-.648 1.63 1.994.426-.538 5.962-5.42.703-5.37 4.06-3.145-1.883-2.286.58 1.222 5.847-5.082 3.898-1.44 5.633-4.164 1.093-1.186 2.608-.054 5.144-4.35 4.046-7.966-3.397-.42-1.914-1.373.163.562 1.295-2.38 1.588.408 3.557-2.35 1.023-2.224 5.67-1.626-4.523-2.143.365-2.204-2.617-3.464 2.131-2.702 5.604-9.04-5.054-3.057.887.11 1.374-3.77 2.977-1.236-3.092-2.407 1.033-1.22-.83.518 1.509-2.617 2.959-2.198-.683-1.604 3.366 2.659 6.772-11.182 4.133-.319 2.321 3.03 4.888-4.145 4.745-12.838-4.606-3.283 3.864.964 2.056zM903 512.868l1.14-.076.788-.052-1.584-.74zM1112.256 493.38l.888 1.556-1.046 3.111 2.46 3.874-5.086-.316-1.648 1.57-4.125 8.657-4.533-1.751-1.457.692-7.52 8.23-2.652-3.497-1.825 1.354-.846 3.288-2.266-.235.112.848-2.418 4.828-4.913 1.446-8.45 7.795-6.99 1.069-3.298 1.859-2.79 3.114-1.365 6.402-4.877.435-.611.634.033 4.982 32.078-3.635 9.293-4.07.325.273 1.138-1.457 6.367-2.37 1.131-2.027 39.315-2.995.623 1.969 1.804-1.803 6.416 6.393.422 3.77 30.219-4.771L1212.822 570l10.395-3.8 8.021-5.775.417-3.062 5.537-10.622 12.204-10.364 10.376-2.572 5.968-5.723.262-2.388-.517-2.116-2.796-.01-1.414.962-1.044 5.54-2.585-6.376-.338-3.432 2.05-2.94.645-2.618 1.107-1.54-.772-.588-15.7-3.512 13.217-2.352 3.775-4.782 2.413 4.231 1.767-.162 1.926 1.88 3.842-.863 2.093-1.776 3.57-7.251 1.759-1.77-1.825-6.317-1.044-1.074-.748 1.344-1.624 6.464-2.333.447-2.157-3.1-1.424-4.696-10.65 4.066-4.684-.049-3.352-12.961 2.521-4.823 3.964 9.04 1.05.563 1.724-.346 6.334-5.833.976-.09-.27-2.449 4.988.87.922-.15-1.02-1.286-1.572-4.073-1.442-1.43-.045-7.336-19.557 3.938-134.822 22.89zM1037.87 690.754l-.896-1.545-.003-.408-.137-18.81-2.384-5.942.412-8.653 3.33-4.422-2.67-1.67.791-3.449-4.716-7.075-22.566-78.78L942 565.762l1.505 1.66 1.906 155.275 2.807.183 1.018-.692 4.707-25.2 5.047 25.584-1.06 3.428 13.348-4.434-.957-4.366.842-3.79-7.012-6.311.13-6.996 74.719-6.905zM871.793 569.535l5.36-2.71-.252-.662 1.76-.104 1.81-.916.85-2.878 1.826-.266-.928-6.382 3.191-7.104 1.426-.325-.765-1.669 1.475-1.38-1.708-3.381 6.024-3.51-2.836-2.474 3.974-.925-.446-.731-20.476 1.071 9.98-12.573-.112-2.192-2.303-3.424-22.02 1.032L761 520.286l3.783 97.812 1.307 1.711 5.233-1.04 5.497 1.739.182 18.492 79.787-2.25-.312-2.766 1.72-1.914-.283-1.816-2.457-1.785 1.247-5.744-4.223-3.602 3.401-1.555-3.055-2.392 5.421-4.795.637-3.846-2.951-2.627 7.059-3.004-3.486-2.169 4.001-3.059 1.168-3.41 1.092.024-.121-2.658 5.045-1.985-.601-6.246 1.204-4.961 2.306-.3-.103-2.199 5.041-3.482-.494-1.295zM751.187 427.092l-1.973-6.258-6.078-6.435 4.732-8.205 1.282-.114-.8-2.116-3.46.937-8.334-6.138-4.796-.022L565.442 392l-5.15 69.844L558 492.966 757 501l-.292-72.034zM712.818 278.585v.006l-1.484-.024-1.544.018v-.042l-.56-.01.009.137 1.598 2.296-.375 4.355 1.28.264.949 4.546-.906 2.721.146.006-.655 2.004-3.276 8.005 3.225 3.496-.772.91 1.202 1.786-.052.857.854.185 1.296.249v.033l-.357 5.388 1.974 3.01-.354 3.388 1.96 2.323.12 2.132 2.905 2.317-.306 3.128 2.389 3.675-1.296 4.215.266 3.137 2.023-.3.273 3.03 2.28.808-.96 4.39 2.301 1.1-1.414 3.501 1.517.732-.43 5.418 1.2 5.846-1.294 4.725 2.293 2.21.039.569.073.674 102.62-1.351.672-.019.013.01 6.982 7.561.44-.258-1.127-5.788 7.089-3.963 1.2-5.652 3.067-4.285-.34-3.626-4.036-4.43 1.774-7.671 9.845-2.314 7.231-4.388.909-5.454 2.78-2.655.926-5.296-.751-3.446-6.099-4.149-1.063-3.574-4.424-3.082-1.144.073.033-.85-2.904-2.02 2.989-.182.042-1.082-1.18-2.268-9.297-2.748-.003-.003-.185-.905-5.16-24.984-120.683 1.676zM526.764 509.354l.65-7.668.586-6.939-5.482-.64-22.834-1.994L367.338 476 339 666.047 359.357 669l2.344-16.028 46.887 5.738-1.212-5.924 104.865 10.937 13.135-154.463.003-.028zM47.28 515.744l.62.168-1.128-1.9L46 514zM18.218 238.827l-7.891 19.312-8.812 7.6L0 271.22l2.022 3.334 5.605 22.256-.136 3.28-1.768 2.507-2.802 23.058 9.686 21.835.422 4.343-1.287 3.962.352 1.426 2.323 3.462 3.005 1.408.45 1.758.328.226.795-.33.325-.417 2.763-7.957 8.283 2.968 7.786 5.809-6.993 1.99-2.866-.207-2.083 1.444-.143 2.185 2.301 9.899-.971 7.545-7.224-13.006-.115-1.667-.738 1.475-.434 18.75 2.572 5.026 5.984 3.045 1.67 6.49-1.849 6.81-3.92 1.815-1.144 5.224 15.965 36.948 2.915 2.776-1.097 5.635 3.107 3.185 1.7 4.717.027 1.716-2.05 3.313-1.505 11.224.343 1.273 11.577 6.117 4.482 4.187 2.523-.756 3.926 1.844 8.405 7.168 1.333 3.718 9.434 7.728.288.546 1.479-1.692 3.625.741 5.496 7.198-.27 5.739.051.152 6.504 2.392 16.973 25.005 1.84 5.891-1.266 16.539L180.498 593l3.303-2.798 3.978 1.271 2.305-2.986.37-2.387-5.881-5.388 1.91-4.69-1.03-3.111 1.057-5.035 3.188-.015 3.361-3.425.99-4.288 1.312-.975.722-8.412 3.413-1.77 1.488-2.743 8.016-3.8-1.436-5.257-3.374-3.365-4.594-13.832-.003-.003.061-.381.513-3.188-20.452-30.307-89.69-139.104.175-.655 26.562-98.856-35.072-10.312L19.849 219zM358.405 190.433l149.708 20.538L528.388 213l12.38-129.278.232-2.406-135.025-17.34-91.822-16.707L270.785 38 264 68.605l5.248 11.168.448 4.335-1.44 1.146 2.071 3.278-1.826.823 1.393 1.14 1.232 3.168 3.754 2.351 4.477 10.442 2.863 3.09-.366 2.777 2.906 2.983-.073.34 1.052-.298 2.156 2.938-.71 1.304.066.078 7.24.435-1.812 6.948-1.268.495.192 1.264-3.355 5.845.061 3.494-1.35.425.454.985-1.07 2.773 1.607.763-1.013 2.758.702 2.087-4.782 2.86.802 2.102-1.83 3.487.985.301 2.217 2.731 1.915-1.154 2.601-.453 2.422-1.67 1.238-3.622 6.165 6.738-.707 2.385 1.244 1.048-.915 2.707.827 1.862-.555 2.385 2.025 3.98.274 2.075 1.333.365 1.122 4.952-.65 2.673-.915.684.348 1.333 1.293 1.872 2.064-.49 3.09 2.65 1.82 5.675-.851 1.44 1.269 2.345-.525 2.349 1.076 1.2 2.754-2.057 2.784-.416 6.15 2.725 1.294-1.841 3.464-1.152 3.851 2.005 5.45-.066 1.387 1.449 3.049-.723 2.336.787-.08-.253 1.986-1.938-.15-1.947 4.608-1.99 2.375 2.02 1.635 5.487.835.99zM1154.068 372.978l95.064-17.427 2.751-4.778 4.322-1.178 2.772 1.082.168-.175.595-.795 4.925-2.516-.897-1.521 8.232-9.04-6.338-5.474-2.693-.359-1.583-3.952-2.943.057-3.245-10.047 1.59 1.335 1.634-1.446.464-2.097-2.956-3.708 3.764-4.607 2.367-7.495 1.945-2.822-.4-.458-6.468-.744-3.72-4.6-.69-4.863-1.998-.226.4-1.325-3.7-.476-1.19-2.748-2.332-.575-18.787 3.805-90.484 16.22-1.634.297-.226-1.47-1.025-6.272-1.814 1.663-4.941 1.32-7.997 7.374L1128.525 377zM777.324 673.787l5.92 7.234.958 3.122-.44 3.318 3.44 2.895-.727 1.518 2.809 3.519-.87 1.988 1.597 2.755 3.124.288-.428.512-.748 3.882 1.882 2.88-1.83 1.048.97 1.68-1.407 1.954.3 2.373-4.754 9.15 1.07 3.3-1.567 3.425 1.058 2.064.57 5.055-1.104 3.58-1.893 2.227-1.821 3.991-1.858 1.767 1.403 1.673 16.029-2.752 30.409 6.535 2.22-2.164-.272-2.95 2.424-2.787 6.224-.064 9.493 4.488 3.402 3.428 3.563.652 6.342 8.713 6.009.076 1.833 1.685 3.666.955 4.612-2.616 2.942 1.816 2.333-1.33 7.872.854 2.92-3.87.431-1.128-.594-2.47 1.985-1.764 3.972-.209 4.357 3.694 6.551 2.607 5.62 6.616 4.364-2.146.315-1.127-1.951-2.404-9.16-3.882-4.875-5.655.17-2.637 2.52-4.861 5.497-4.516.788-6.359-.38-.327-.332-.067-5.473 2.837-3.39 3.21-3.915-.367-1.82-6.225-1.486.236-4.087 3.38-6.405.709-5.845-4.534 1.693-7.659 7.957-2.967 14.08 3.77-1.508-3.86-3.833-3.247-1.836-4.406 2.302-9.865-54.282 2.467-.048-1.067-1.382-1.173 1.86-2.073-2.678-7.107 4.312-1.576.536-2.497-1.336-4.101 3.145-2.816 1.709-8.561 7.414-6.51-.754-5.077 2.82-.121 2.406-4.65-5.563-4.233.058-3.443-2.721-3.91 2.254-1.576-1.836-1.49 2.07-5.456-2.67-1.506.188-.555L777 641.212zM1307.842 236.154l-2.142-2.382 1.206-5.852-2.701-18.488 3.785-16.1-1.211-12.52 4.573-2.783 4.46-6.71.188-1.728-3.603-4.932 1.891-5.882-.439-.777-40.849 9.78.553 1.285-.513 1.84 1.35 1.786.328 5.931 3.443 5.088-.356 3.326 1.406 4.082-1.31 2.357-.278 4.559 4.27 10.141-.438 2.911 1.165-1.422 3.822 4.002 4.592 24.787.869 1.547z"
	}), _react2.default.createElement("path", {
	  d: "M1291 237.995l.003.005 15.997-2.931-.08-.069zM1283.864 321.168l1.327-5.084.863-1.41.933-8.997-20.908-7.677-1.793 2.66-2.445 7.768-2.408 3.009 2.326 2.983-.972 4.504-1.403 1.269.294 2.5.576 1.82 2.765-.056 1.694 4.317 1.82.248 9.297 8.202-8.757 9.826.687 1.193-1.187 2.186-5.214 2.72-2.102 2.86-1.257 3.885 1.015 1.152 7.303 5.876 4.005.352 3.384 2.168 5.661-.96 1.106 5.518 7.891-17.69-.615-2.362 2.636-2.1.336-.82-.376-9.75 1.124-2.794 1.388.23.142-8.47-.82-1.506-2.658-2.269-3.81-1.021-.44-.535-.363.932.124-1.226-.563-.687z"
	}), _react2.default.createElement("path", {
	  d: "M1267 298l-2.116 2.55L1262 308l2.884-7.447zM1334 256.759l4.668 19.168-.077.073 6.267-3.707 1.368-1.66.774-7.433-2.961-1.209-.544-.215v-.006l-.514-2.626-.976.064-1.19-4.208z"
	}), _react2.default.createElement("path", {
	  d: "M1344 263.004l.768.3L1344 263zM1081.905 554.848l-2.918 2.347-1.987 4.448 8.746 5.683 3.576-.265-.434-2.934 7.314 13.54 6.656 6.552-.689.106 7.575 3.98 3.294 4.555 9.18 5.841.227 3.605 2.782 1.35.276 2.026 2.354 1.058.427 1.724 8.473 4.022.012 2.53 3.88 6.858.446 3.617 4.775 2.173 4.565 7.498.67 5.653 3.674 1.185-.13-.375.843-2.102 4.972-3.797 2.23-.341.518-1.07-4.301-5.823-.665-1.883.898-2.422 16.936-2.52 1.823-.902 10.281-12.02 1.22-.202 1.37-1.407.62-4.025 4.895-2.636 2.2-2.618.637-2.617-1.93-3.175 3.356-3.58 5.15-11.131 6.15-4.421.148-.966-35.459-26.449-32.006 5.043-.658-5.844-3.501-3.48-3.185 3.175-1.402-4.412-35.191 2.675-.88 1.573-6.592 2.45-2.542 3.25-1.283-1.084-6.84 2.986zM1212 571l-36-26zM1266.088 421.14L1263 434.468l2.869 8.322.289.21 1.336-.37.886-.995L1275 413l-6.312 2.444-.368 4.43zM122.3 0l.949 3.611 2.524.815 3.458 2.263 1.527 3.672-2.854 1.629-1.36-1.457-.984 2.881-3.314 2.483 2.402 3.096.433 9.265-4.915 13.405-2.57-1.527-.591-3.192-1.39.085-5.208 4.881-4.589 2.049.662.47-2.448 4.608-5.808-1.316 1.728-6.667 8.244-8.644 2.433-.522.488-.465 1.421-2.812-.134-1.922-4.012-.636-4.876-4.17-6.003-1.466L75.805 5.675l-1.207.809-2.134 2.784-1.25 3.416-.22 2.694 2.76 8.716-.928 25.109 2.25-1.663 1.83 5.018-2.122 3.237-1.787 1.5-.549 2.07.128.482.424.329 2.503.12.342 2.625-2.64 8.56-1.69 2.136-2.268-1.101-.247.902 1.54 2.079 9.064 2.45L89.4 90.077l.256.287.747 4.332-1.372 9.87 8.561 5.394 6.705-.097 5.36-1.74 12.473 3.665 2.515 3.95 13.379-1.011 3.143 2.598 5.375.455 7.126-1.34 6.564.667 2.726-1.683 11.607 2.332 2.689-1.12L224.244 128l-.27-.911-.267-.779.027-.03v-.003l1.985-2.272-1.451-6.936L245 32.515 144.981 6.601zM1222.095 394.151l-.65-.832-1.304-.712-3.154-.744-1.637-1.882-4.536-.133-3.245-2.915.777-3.204-1.622-1.009-3.36-.121-1.486 7.5-14.471-8.099-.608 8.863-3.88 7.464-2.789 2.903-.857-.228-2.619 6.024-3.497-1.656-5.092 15.388-8.124-1.316-1.468-2.739-.495-.073-.359 4.538-1.902 3.872.402 1.878-2.957 3.93-1.051 5.881-5.651 11.343 2.351 2-2.181 2.556 1.194 1.626-6.022 5.483-2.272-1.06-5.336 3.765-1.847-.638.422.945-1.6 2.012-9.204 4.362-3.618-2.207-.55 1.237-6.411 3.687-7.258-2.507-3.27-2.733-.385-2.149-1.507-.927-14.891 13.975.112 2.982-3.415 2.462-.142 3.188-5.381 2.544L1074 492l15.492-2.027 23.21-3.034 120.346-20.305 15.319-2.587 19.633-3.93-1.164-3.902-7.407-.286-.346.137-1.094 1.948-4.415-.666-3.883-1.692-.124-4.775 5.733-1.277.562-.407-.11-.192-2.746-.808-1.871-3.784-.441-2.833 2.607-2.024-1.045-1.529-2.762-1.133-2.27-6.234 2.2-1.003.252-5.11-.823-2.394-2.595-2.383-12.01-2.359-5.247-3.316-8.85-2.565-1.584-2.13-.559-1.781 1.076-4.207 1.464-1.133.225-3.216.027-.77 1.547-1.014-.046-1.669zM1084 476l15-13zM1074 490l1.644-3z"
	}), _react2.default.createElement("path", {
	  d: "M1112.052 485.994L1232 466l-120 20zM731 378.333l.952.412.95 7.265 5.048 2.71-.334 1.993 2.029 2.858-.3 2.338 6.794 5.018 4.688-1.274 3.199 8.478-3.705.324-2.784 4.835 4.97 5.272 1.713 5.44 6.095 2.075.309 75.761.606 15.63 119.466-3.31.8-.037.01.015h.003l3.714 5.52.219 4.202-6.474 8.142 13.85-.724 2.15-3.298-3.344-4.713 3.348-.617-1.338-1.733 3.126-2.118-1.667-6.326 4.766-1.174.128.51.676-1.708.597-1.54.006.003 3.724 1.745 2.01-5.52-.04-3.805-7.216-4.016-2.532-6.57-2.186-1.162 2.09-5.697-2.478-5.085-.121-3.481-10.4-8.194-3.154-.507-9.754-8.824-.783-5.483 4.415-9.932-.497-3.14 1.759-3.288-3.033-2.096-3.338-.917-2.832 2.879-3.284-.226-2.61-3.97-2.79-10.593-6.88-4.94-1.574-2.686-7.65-6.558-4.375-14.255.88-8.254-6.42-6.987-15.357.477z"
	}), _react2.default.createElement("path", {
	  d: "M906.788 500.98l-.012-.928-.008-.896L906 499zM904 511l-3-2zM899 511.982l.008.018.88-2zM907.052 504l-.052-3zM907.012 501.928L907 501zM881 514.052l1.068-.032-.012-.02zM839 384l-6.997-7H832zM706.219 175.983l-1.974-7.454 1.039-8.357-.793-.288-.86-23.48-6.038-19.402-.225-13.403 1.403-3.638-2.526-8.799-3.635-.09-89.801-4.162-59.32-4.91L534 181.26 709 191l-.17-10.886zM265 281.174l-56.685-12.251-14.25-3.321-.006.027-1.51-.38-1.44-.337.005-.027L120.404 247 94 344.901l89.01 137.549L201.668 510l.137-.808.188-1.121.006-.004 1.665-.364.948-19.507 1.686-4.279-1.343-3.16 2.592-3.567 5.23-3.993 3.029 1.988 3.126-.022 2.04 4.5 1.063.377.738-.346 2.604-3.707L260.64 302.61zM120 247l-26 99zM387.288 334.822L514.346 349l2.157-22.66 4.275-44.858 2.314-24.27L527 216.174l-20.272-2.041L360.666 194 338 326.928zM526 216l-20-2zM1367.2 59.413l-1.581 5.088-7.486 4.056-6.715-.243-3.461-4.074-2.958-1.442-1.394.185-1.649 1.767-6.234 20.784 1.552 41.544-.6 1.958-3.046 4.904-.024 1.372 1.449 2.277.087 3.136-3.615-.331.879 3.376-6.516-1.002-1.888 1.397.524 1.648 8.816 27.746.01.042.002.006 8.686 30.572 5.264 4.102.606 2.984.973.735 4.182-5.814 4.11-11.39-.158-5.253 2.773-5.137 3.58-3.145 2.987-.018 1.804 2.219.13-.322-.015-5.164 2.803-1.406 1.934 1.91.02-.006 1.061-.768.8-3.522 1.789-2.832 3.376.264.827-3.613-.555-3.14.84-3.478-.37-4.958 2.343-3.203 1.797-1.278 2.4.21 1.425 3.612 1.033 1.293.936.022 2.161-1.776 4.976 1.991.549-.428.673-2.404 2.721-4.12 2.294-.674 1.658-1.47.543-3.22 6.755-3.313 1.154-2.201 2.934-1.227 1.03-1.684 3.376-1.36 1.443-2.016-.01-1.227-.478-.744-3.424.35-.252-2.91.685-2.58-1.606-3.558-1.419.592-4.273.44-4.855-1.426-2.433-2.554-2.919-7.842-7.182-1.187-13.232-44.892L1368.85 59zM937.248 466.32l-.248.06.456.356-.252-.736zM939.892 461.092l2.655 1.814 3.7-1.59-.71-8.944 3.948 8.536 3.454-1.01 7.325 4.102 1.685-3.494 6.456-3.98 2.773 3.297 2.41-.508 1.448-.632-.364-3.17 1.816-1.216-1.166-2.699 3.187-.387-3.388-5.779 8.455 5.646.57 2.621 4.7 2.007 1.947-1.817.18-4.784 1.913-4.21 3.831-1.007 1.258-4.924 4.402-3.389-1.422-6.828 6.325-1.61 2.47 1.48 4.368-3.31 3.803-.495.079-.895-2.865-.61 1.346-3.398-2.175-2.94-.024-.034 1.045-.93 1.245-1.177-9.435-87.06h-.006l-.152-1.445-.034-.323-51.967 4.776-5.793 4.57-4.967-.067-3.084-.958 6.049 77.654.094 1.188-2.29 2.397 1.175 3.053-1.704 3.173 3.733 4.885-.4 3.125 1.618 4.431-3.557 6.771.86 2.723-3.445 1.847-2.278 6.487-2.54-.158-.374.75 2.024 3.38-1.009.78 1.783.492-3.873 2.66.383 3.02zM937 463l3-2z"
	}), _react2.default.createElement("path", {
	  d: "M1015 418.228l.032.044 1.344-1.272zM843.029 276.143l5.141 25.488 8.766 2.619 2.142 4.16-.063 1.59 67.711-4.24-3.613-24.32 6.296-28.491.655-17.928L938 213.754l-.257-.728-3.54 4.848-.852 8.302-3.704.954-11.57 12.394-.44-5.99 4.072-10.34 2.54-2.668 1.441-3.062-1.655.01.682-1.227-3.25-2.404 1.547-5.818-5.323 1.141.054-5.029 1.281-1.829-.84-2.523.795-.808-.921-1.728.365-.703-1.459-1.355-6.392-1.386.903-3.56-.326-.658-8.782-2.196-2.824.96-36.975-9.745-2.806-5.903-1.67-1.089-2.173.752-.61-1.651-6.875-.462-2.659 2.982-1.857-3.465 1.13-5.27-.315-3.203-1.413-1.297-14.954 10.2-5.67 1.448-4.58-.398-2.153-3.19-.429-.343-.758 2.037-1.357-.033.538 18.912-2.368 2.857-7.452 3.912-2.26 4.826-1.803 1.814-.076 2.52 2.821.661 3.172 5.842-2.489 5.124.369 6.32-1.148 1.421 1.16 4.393-1.257 5.744 1.547 2.09 5.374 1.948 2.483 3.33 3.68-.41 4.745 2.484 5.35 5.794 1.682 4.01 11.45 7.79 2.703 5.463z"
	}), _react2.default.createElement("path", {
	  d: "M848 300l-5-25 .191 1.323L847.997 300zM1295.958 311.089l-.958 2.618.86 2.265.601.028 28.46-17.478.079-.522-22.374 8.25zM1176 892.832l3-.252-.01-.304-2.122-.276zM1222 390.26l.22-.208-.072-.048-.008-.004zM1222 390.26l.14-.26zM1222 390.208l.22-.208zM1080 440.337l5.106 5.253-.121 1.651 4.991 4.838.888 2.64 3.033 1.136 1.358 1.929 3.139.24 1.752-1.653v.003-.003l.355 2.615.991 1.267-.621 1.17.967.597.43 2.415 2.193 1.843 5.188 1.722 4.364-2.527 1.543-3.51 5.17 3.17 7.08-3.387-.725-1.63 1.61-2.866 3.579 1.242 5.488-3.901 2.035.952 2.498-2.286-.997-1.37 1.761-2.076-1.84-1.578 6.598-13.327.994-5.988 2.566-3.431-.33-1.557 2.225-4.56.358-6.984 5.297.76 1.486 2.784 4.075.665 5.346-16.26 3.76 1.79 2.401-5.56 1.65.437 1.395-1.459 3.366-6.638.688-12.86 15.046 8.473.864-4.398-.321-1.758-2.475-.852.258-.8-.403.177-.034-.064-.042.013-.01-.092-2.1-3.538-1.726.415-4.788-2.1-1.725 2.32-1.916.458.336.39-.849.474.334.278-2.114 2.637-3.672.787-5.103-.918-3.82 5.497-2.878-.925-.482.32-3.936 6.377-6.744 6.34-2.771-19.13-27.009 4.332-3.017-19.758-1.698 6.297.34 6.76-.964.33.23.935-1.252 3.171 1.104 1.328-.843 4.676-8.433 9.655-4.254 2.866-2.117-1.508-1.913 3.98-2.863.955-.952 2.265.552 3.18-1.4.862 2.816 6.504-3.796-.9-3.587 4.343-1.168-5.653-.77-.06-2.871 7.035 2.077 6.202-2.893 1.575-.646 5.195-6.38 1.81.92 4.848zM1120 349.384l1.292 1.616-.376-2z"
	}), _react2.default.createElement("path", {
	  d: "M1102 456.004l.468 2.996-.464-3zM1171 400l-5.676 16-4.324-.655 4.324.655zM1184 389l-3.534 6.559L1179 397l1.466-1.441zM1099 458h.003l1.997-1.996V456z"
	}), _react2.default.createElement("path", {
	  d: "M1099 457.896l1.366.13.634.974-.337-3zM1018.05 500.363l-37.03 3.573-1.276 1.44-36.176 2.969-.668-1.256-3.196-.054 1.402 6.332-39.374 2.59-.344.867-.918 2.426.08.291-.256.17-.633 1.668-.264-1.064-1.08.721 2.415 3.1-3.573.652 1.779 2.483-3.19 4.843 2.63 4.264-2.27.522.334.291-1.445 2.575-4.585 2.635 1.45 2.83-1.547 1.425 1.426 3.06-3.633.815-2.205 4.853 1.247 8.445-2.928.419L884 565l15.284-.895 39.42-2.31 71.572-6.099 34.929-3.921-.046-6.49 2.262-2.335 3.77-.33 1.064-4.95 3.89-4.176 4.268-2.274 6.345-.961 8.289-7.576 4.32-1.261 1.399-2.772-.48-3.721 3.484.36.459-1.773 5.099-3.746 2.265 2.957 5.731-6.05 2.9-1.368 3.126 1.198 3.36-6.753 2.81-2.65.428.023-.018-.03 1.07-3.169-.76-1.322.672-3.606-52.992 6.908-2.636.276zM901 517l40-3z"
	}), _react2.default.createElement("path", {
	  d: "M1054 497l-73.994 7.994L980 505l36.899-3.687zM1044.056 554l-.056-7zM939 563l.054-.003 70.922-6.994.024-.003zM899 538l-3-5zM896 533l3-5zM901.432 517l-.432 1.144.452-1.144zM901 517h.02zM967.055 702.4l-.055 2.85 7.327 6.52-1.085 4.838.456 2.06 2.478-2.868 2.937-.683 2.706-2.655 2.667.145.44 2.846-.602 1.977 19.307-4.215 4.08 1.034-.237 3.944-.3.16 22.964 9.235 6.172 7.554 1.66 1.08 14.162-4.346 7.64-4.92 2.43-.354.055-2.528 3.548-3.13 8.37-.828 6.108 1.581 10.356 8.825 3.573 1.249.915 5.122 2.624 1.086 6.196 5.945 10.66 3.805 2.155 2.513 4.953 40.241-.167-4.603 4.947 1.17 3.38 2.257-1.915 12.91 1.378 5.125 12.405 14.546 5.038-2.746 2.703 9.369 1.748-.814 2.353 1.485-1.633 3.738-.115 1.18 5.537 6.168 5.09 9.895 2.562 2.093 4.786-.357 4.412 3.115 7.686 11.534.726 7.043.274.447 1.764.962 11.83-3.063 6.886-4.585 4.056 1.155.879-2.06-2.62-1.553 3.295-23.981-4.275-28.741-22.314-38.149-2.183-13.63-17.053-20.914-20.21-45.095.553-2.126-11.043-1.258-.997 1.67 1.587 5.152-.146 8.108-5.6 1.264-2.411-2.55-1.1-4.03-77.58 4.254h-.013l-1.1-1.373-2.56-3.16-.134-.36-1.998-4.276zM1041 695l-74 7zM1256.313 352l-2.112.571-2.201 3.789 10.213 39.64 15.304-3.044.483-1.59-21.137-27.394.207-3.372-1.839-2.032 2.103-6.06.055-.074.006-.014z"
	}), _react2.default.createElement("path", {
	  d: "M1256.95 354.082L1255 361l2-7zM191.04 262l14.011-59.14 3.252-5.322-.428-3.05 2.42-2.126-.867-2.126-5.196-2.095 1.22-8.11 7.152-8.445 3.492-1.983 1.783-2.335.79-3.394 4.197-4.321 3.064-6.033 6.07-6.764-.74-4.372-4.393-3.333-.124-.475-1.644-5.626-47.482-11.634-2.612 1.107-11.287-2.3-2.57 1.612-7.125-.739-7.062 1.348-6.713-.578-2.915-2.44-13.908 1.062-2.864-4.558-10.41-3.099-5.1 1.603-7.814.115-10.92-6.973 1.562-11.416-.519-3.059-3.946-4.516-.652.797-5.13-3.646L70.024 84l-.628.228-3.719 9.88 1.038 1.88-1.948 2.76-1.034 4.884-2.767 3.263-24.61 58.877.41.13-.865 5.736-3.94 1.155-3.291 3.211-5.688 10.598L20 215.872l98.787 29.013zM20 216l98.997 30H119zM226 132l-48-12z"
	}), _react2.default.createElement("path", {
	  d: "M191 260.881L119 244l.018.006L190.731 262zM119.004 244.004l.016.004L119 244zm.02.008h.004l-.008-.004zM340.53 296.435l-58.04-10.572L268.038 283 234 448.95 365.948 472l19.37-128.778.682-4.527-51.343-8.14zM705.964 311.59l-.006-.015-2.053-5.203-10.558-4.159-2.598-2.674-13.616-.166-2.029 2.592-3.118.248-9.898-5.532-2.245-2.471-8.954-.555-126.91-8.6-.806-.055L517 349.5l49.937 5.547 1.521.13-.335 4.508-2.132 28.676L735.915 395l.085-.652-2.075-2.886.183-1.067-4.512-2.398-.935-7.045-1.904-.816-.03-.936-.25-3.653-2.763-2.644 1.589-5.757-1.144-5.545.3-3.765-2.223-1.06 1.417-3.49-1.901-.9.907-4.12-1.604-.558-.158-1.774-2.048.3-.59-6.93 1.056-3.41-2.206-3.371.25-2.54-2.687-2.132-.143-2.47-2.151-2.535v-.003l.377-3.59-1.944-2.952.246-3.75-4.238-.813z"
	}), _react2.default.createElement("path", {
	  d: "M711.324 313l-.324 3 .328-3zM723 374l2-7zM713 322l.496-3zM726.031 381.07L728 382l-1.93-.912L726 380zM517 349l7-64h-.003zM1317.554 149.965l-.813 6.657 1.397 2.512-1.8 5.673 3.338 4.631-.387 3.628-5.459 8.072-3.178 1.966 1.06 11.113L1308 210.24l2.652 18.44-.987 4.872 2.171 2.448 27.467-6.724 8.05-7.709 1.644-.131.003-5.105-2.527-1.922-.618-3.023-5.182-4.05-8.993-31.72-9.073-28.616-4.262 1.59zM610.531 514.162l1.83.122v.006l-3.533 66.883 2.654.216 6.193 6.288 2.161-.825 3.133 1.142 2.049-3.554 5.927 6.3.573 3.606 4.923.161 6.056 2.82 4.425-.527 3.225 2.92 2.462-1.945 9.226.036.43 4.711 3.882 1.398-.393 3.404.692.335 6.821-4.202 2.816 1.456.238 1.967 2.721.164.985 2.187 7.552-2.924-.2 2.82 10.724-2.984 3.109 3.152 7.89 2.332 1.138 1.328.265-.767 2.94.164 1.424-1.952 6.742-2.728 3.38 1.157.067-.509 7.162-2.54 1.774 2.695 4.139.342 3.541-3.676 8.629 4.534 2.62 3.265L762 616l-4.313-95.571h-.064l-.006-1.541-.067-1.51h.061l-.058-14.294-199.501-6.962-.006.08-1.497-.131-1.545-.052.006-.082-20.908-1.821-2.865-.116-.588 6.949-.649 7.665zM687 612.62l.44.38.748-.675-1.02-1.325z"
	}), _react2.default.createElement("path", {
	  d: "M758 517l.088 1.984-.008-1.984zM758 520.015l4.986 94.979.014.006-4.316-95zM555 496.104l2 .072-1.988-.176zM558.076 496l-.076 1.044L757 504v-.006zM530 509l.848-8z"
	}), _react2.default.createElement("path", {
	  d: "M758.012 521l.08-.004L758 519zM758.076 519l.716-.013L758.06 504H758z"
	}), _react2.default.createElement("path", {
	  d: "M758 517.012l.008 1.48.088 1.508.78-.018-.16-2.982zM758 504.012l.06.004v-.012L758 504zM1289.492 267.535l.927-26.521-1.506-2.856-4.417-23.936-.756-.8-2.542 3.12-2.061-4.984.57-3.823-4.158-9.924.525-6.2.807-1.464-1.17-3.413.308-2.87-3.247-4.824-.32-5.793-1.67-2.228.619-2.234-.339-.785-37.335 8.276-12.574 13.78-2.77 10.922-7.969 8.052-.762 1.391.201.455 2.747-.549 2.7 2.195.262 3.304-2.347 2.334-.826.003.03.07 2.64 2.264 1.994 4.76-.347 4.468-7.792 3.098-6.37 7.154-4.201 2.216-9.105 2.067-1.51-.197-4.822 2.665-4.776-2.498-7.392.076-22.18 8.924 6.557 12.147-5.325 6.863-1.512 3.316-1.978 1.658-1.265.476L1135 288.65l1.049 6.866 108.003-19.931.368-.076 4.478 1.112 1.098 2.559 5.53.718-.385 1.276.723.08.902 6.398 2.414 3.005 6.392.742 1.686 1.931 24.02 8.691-.012.115-.302 2.865 1.762-.4 1.113-3.453-1.35-1.406-1.665-1.737 5.176-5.139-1.74-1.967-3.646-23.62z"
	}), _react2.default.createElement("path", {
	  d: "M1243 277.1l.396-.092 4.604 1.46-4.62-1.468zM1257 288l2.192 2.41 5.808.59-5.808-.593zM1267 295l24.997 7.898-.013.102.016-.102zM711.668 191.262l-.275 1.449.107 1.65-.413-.025-.288 1.52.012.768-.224.343-.006.034-2.391 3.676-3.889 2.783-.287.905 3.248 5.222 3.776 1.35 2.556 3.42L712.66 275l127.896-1.546-1.065-7.605-2.104-4.022-11.709-7.81-1.95-4.558-4.74-4.903-3.34-1.644-4.569.498-3.016-3.961-5.45-1.939-2.96-3.919 1.41-6.346-1.383-5.15 1.396-1.695-.352-5.897 2.18-4.387-1.791-3.226-3.972-.915.19-6.2 2.496-2.458 2.296-5.05 8.197-4.22 1.016-1.294-.609-20.902 2.434.061 1.485-3.889 2.863 2.249 35.864-32.963 7.87-3.315 6.757-6.517-5.129-2.072-10.876.21-.312-.076-7.085-2.254-3.433.313-5.474 3.04-3.218.517-.53-.197-5.63-2.646-3.33-3.54-5.18-1.488-3.004-2.24-6.24-2.257-2.32-2.78-7.707-3.414-10.074-.69-3.307 2.139-5.055.446-.025-.006-.036.003-.331-.076-4.189-1.242-.015-1.036-.279-.277-6.858-2.37-6.372.736-.625-.65-3.631.264-.622-.911-3.662-8.416-.811-.984-4.67-12.24-2.088-.283-.021 14.61L698 91.012l2.572 8.92-1.568 4.046.212 12.635 6.084 19.417.808 21.713 1.145.413-1.27 10.199 1.772 6.674 2.765 4.196v.003l.018.03.007.38.753 11.618z"
	}), _react2.default.createElement("path", {
	  d: "M711 194.97l.54.03-.14-2zM711.236 190.987l.748.013-.984-12zM711 181v-.004L708 176zM810 244.656l5-.656zM841.388 275l.08-.003-1.464-7.99L840 267zM941.767 191.084l2.707-1.489 5.129-5.107.605 10.014.104-.015 6.88-8.738 12.603-3.914 2.598-3.859 6.063-1.908 12.362 3.516 1.84 1.932 1.44-.158.188-2.415 1.463-3.367 4.22 2.024 1.43 1.485 7.601-2.433-1.147-.51-1.792-2.207-3.233-1.504-.934-5.296-1.345-2.27-.37-1.64-.402-.453-9.105 1.735-8.706-2.428-.569-5.372-.638-1.233-2.352.173-3.857 2.662-16.956 2.193-7.215 4.306-2.632 3.691-3.03 1.283-10.683-1.17-4.514 1.233-8.67-8.799-7.474-3.488-6.48 1.741-1.633-.38-5.116 5.831-.274-11.16 2.248-3.77 2.93-1.681L914.461 137l-3.367.252-29.355 22.412-11.353 3.719-8.152 6.48-1.235.183.818.529 2.589 5.366 34.995 9.097 2.82-.945 11.066 2.725 1.466 2.926-.404 1.571 4.152.887 3.805 3.488-.705 1.34 1.229 2.28-1.065 1.069.736 2.187-1.636 2.559 4.045-.857 1.616 2.613-1.46 5.424L927.39 214l12.53-23.068zM929 214l-3-2zM1008.6 321.613h.003l.181 1.708 32.624-3.807 6.272-9.605-.407-5.127 1.876-6.406 1.752-2.331-.353-2.799.687-3.226 3-3.852 4.735-.624.03-14.832-2.747-4.601-3.498-14.423-8.163-11.695-9.136 4.31-.266.333-2.129 7.773-6.492 4.698-4.366-1.002-2.072-2.89 2.63-9.98 5.575-5.882 1.436-4.671 2.165-3.16.576-2.199-3.456-13.076-1.821-3.198-.74-3.978 1.322-2.49-2.572-4.033-2.748-2.016-7.119-1.925-2.687-1.717-2.355-.663-5.828-3.797-1.885-.526-3.17.978-1.248-1.048-4.46-.834-4.034.883-1.342 2.029.8 3.693 2.849 3.177-1.4 2.814-8.98 4.103.034 11.087-2.437 1.164-2.421 5.215-2.21-4.555-1.059-5.582-.31-.543-.404.314-2.34 3.095-4.955 3.868-.44 3.83-2.044 3.2-.109 12.556.992 2.276-2.66 2.539-1.751 17.68 9.043 18.902.675 16.198-8.171 27.392L959 326l48.352-4.277 1.248-.116z"
	}), _react2.default.createElement("path", {
	  d: "M1008 323.152l1.656-.144V323zM1309.537 266.613l-2.402-2.746-14.135 3.284 3.509 22.662 3.008 3.397-5.039 4.983.776.807 12.982-7.77 1.24-3.292 3.72-2.94 6.865-.242 15.55-5.82-.35-2.245.739-.694-4.526-17.997-21.008 5.078zM1175.387 373.505l-.06.967 3.062.528 1.147-.235-1.003-.792 1.46-.772-1.157-1.279 5.657-1.274.507-.648-12 2.123zM1248.45 371.497l-2.27 1.704-.962 2.17.317 1.85 1.595 2.48.09 2.874-2.22 3.732 2.293-.357 1.611 1.576 2.11 8.362-2.217 2.467-.594 1.42.059 1.936 1.005 2.265 2.991 2.287 3.665-.64 2.997.826 3.889 5.615.799 2.777.221.159 9.964-4.122-.987-3.606 3.136-6.597.058-2.061-17.357 3.497-8.93-35.111-.302 2.146z"
	}), _react2.default.createElement("path", {
	  d: "M1197.16 368.453l-6.16 1.145 2.357 1.033 4.558-1.1.64 1.573.641-.659.312 2.746 2.442-.647-1.043 3.24 1.33.455.474 2.585 4.222.152 4.15 2.602-.861 3.568 1.06.957 4.727.136 1.862 2.147 1.487.356 2.076-2.445 6.622 4.346-1.883 2.696 6.555 5.8-7.682-4.181-.366.522.218 1.446.148.935-1.176.774-.886.583-.13 3.742-.166.13-.217 3.119.211.143 3.696.234 5.38 1.764 3.074-.72 2.33 1.746 3.584.295 3.134 2.28.188.049-1.826-4.012-6.625-4.075 4.201-1.242-3.025-7.65-1.179-12.705-2.56-4.176 9.022-9.462 2.363-6.732 2.542-.268 2.019 1.242-.598-2.383-.387-1.537zM1156 376.852l1.99 13.148 2.41-2.168 4.3-6.508 2.016-1.282 2.186.67 2.487-3.424L1172 374z"
	}), _react2.default.createElement("path", {
	  d: "M1191 370.508h.003L1198 369zM1156 376.997V377l15.997-2.997.003-.003zM1173 372h.003l11.997-2zM1207 379.196l-5-.196zM1224.392 398.658l1.172-.658zm-.036.02L1224 403l.22-.143.172-4.2zM1225 395.02l.3 1.888-.288-1.908zM1225 395l8 5zM1234 400l-7-7zM1220 390l2-3zM1225 394.953l8 5.047-6.826-7z"
	}), _react2.default.createElement("path", {
	  d: "M1171.784 374l-.784 3 .788-3zM1158 388l-2-13zM1176 375.928l-3-1.928zM1191 369l3 1.36-2.996-1.36zM1202.628 380l-.628-3zM1171 374.004h.004V374zM1156 375.004V375zM1191 369h.004zM1173 374h.004zM1248.796 364l-.796-3zM1250 367l8 35zM1070.612 553.322l.894-.387-22.532 2.667v.019l-1.262.133-1.784.211v-.024L1013 559.404l22.492 77.426 5.156 7.48-.604 2.613 3.674 2.265-4.8 6.289-.338 6.993 2.37 6.103.134 18.557 2.628 4.461.204-.018.357.968 1.137 1.932-.412.04 1.284 3.481.018.04 2.339 2.867 78.717-4.304 1.551 5.662.702.741 1.582-.357.095-5.26-1.845-5.973 2.698-4.504 12.854 1.46-.838-6.89L1155 643.645l-5.769-1.836-.868-7.196-3.687-5.758-5.527-2.49-.622-4.96-3.958-6.66-.006-1.425-8.092-3.79-.414-1.673-2.555-1.13-.287-2.073-2.927-1.403-.244-3.802-7.497-4.713-.35.052-.635-.726-3.155-4.313-7.998-4.147-1.552-2.568-3.911-3.802.027.178-5.769-10.014-3.667.269-11.845-7.604 3.369-7.45 2.622-2.084.097-.526z"
	}), _react2.default.createElement("path", {
	  d: "M1047 555.751l.003.249 22.76-2.889.237-.111zM1044 555.248v.032l2-.28zM1039.149 686.575l2.318 4.425.533-.042-2.851-4.452L1039 668zM1043.952 695l.54-.04L1043 693zM1069.973 553.3l-.973.512 9.99-1.748.01-.064zm9.017-1.236l-.106.7z"
	}), _react2.default.createElement("path", {
	  d: "M1071.227 553.188l-.227.136 7.994-1.3.006-.024zM1047 555.196l1.656-.172V555zM1011 557.993l.003.007 32.997-2.818-.003-.182zM1044 555.448l.003.3 1.755-.248 1.242-.196-.003-.304zM1044 695.029l2 2.971-1.548-3zM1043 691.024l.736 1.256-.468-1.28zM1047 703l79-5z"
	}), _react2.default.createElement("path", {
	  d: "M1043 691.043l1.578 2.957.422-.034-.816-2-.632-.966zM221.852 483.568l-3.447-1.23-1.752-3.895-2.067.015-1.994-1.315-3.322 2.553-1.164 1.663 1.17 2.764-2.046 5.22-.937 21.182-1.936.43-1.17 7.076 4.122 12.447 3.43 3.43 2.323 8.517-9.409 4.476-1.458 2.694-2.749 1.428-.7 8.118-1.506 1.123-.928 4.04-4.84 4.941-1.998.01-.382 1.824 1.122 3.405-1.528 3.768 5.51 5.061-.742 4.78-4.07 5.297-4.402-1.406-1.982 1.684.03 1.696 99.633 61.133 53.06 8.503L364 474.162l-112.22-19.437L233.218 451l-5.526 26.698-3.246 4.65zM881.183 569.33l1.016 2.636-5.657 3.872.153 3.299-3.028.39-.592 2.405.778 8.01-5.181 2.02.17 3.727-2.14-.049-.75 2.17-1.21.918 1.423.876-.393 3.622-4.358 1.84.595.525-1.092 6.576-3.491 3.058 1.668 1.29-.44 3.254-.707.32 1.958 1.657-1.217 5.563 1.878 1.355.708 4.51-1.78 1.966.188 1.644.796-.021-.598 1.755.083.72 2.482 1.407-2.23 5.88 3.282 2.664-3.092 2.158 1.561 2.245-.049 2.909 6.41 4.882-4.41 8.53-1.219.054.506 3.4-7.94 6.973-1.717 8.602-2.44 2.188.982 3.018-1.061 4.968-3.028 1.108 2.263 6.008-.415.464 54.99-2.5-3.01 12.9 1.186 2.847 3.882 3.296 2.253 5.761 5.483-3.17 4.55 1.013 5.921-3.983L942 722.77l-1.9-154.215-2.326-2.554z"
	}), _react2.default.createElement("path", {
	  d: "M881 570l1.332 3-1.328-3zM860 637.74l.36.2-.108-.94zM909 728l-2-5z"
	}), _react2.default.createElement("path", {
	  d: "M860 636.024l.26 1.976.788-2zM708.72 309.836l.588.104L708 308zM659.725 288.222l5.142 5.554 8.492 4.666.874-.07 2.138-2.729 16.409.2 3.247 3.343L706.073 303l-.393-.422 3.834-9.71 1.292-3.85-.378-1.789-3.366-.689 1.076-1.895-1.313-2.08 2.068-.558.08-1.115-1.487-2.119-.229-4.25 1.408.02 2.418.034.917-59.619-1.383-1.855-3.89-1.393-4.529-7.309 1.02-3.191 4.43-3.188 1.583-2.596-.024-1.567-8.176-.146L533.311 184l-6.01 62.752L524 281.275l135.661 9.145zM707.78 307.992l.508-.592L707 306zM227.909 129.622l.216.814.887 2.594-.21-.052.918 3.45 4.542 3.438 1.192 7.029-6.948 7.72-3.134 6.117-3.793 3.896-.948 3.471-2.64 3.25-3.54 2.005-6.042 7.245-.744 4.9 4.18 1.683 2.192 5.34-2.833 2.478.35 2.506-3.71 6.062L194 262.158l72.296 17.078.006.003.03.006L339.882 293 354 210.307l-2.994-3.764-1.466-4.944-.244-.207-.87.375.095 1.207-1.655 1.621 1.357 4.215-7.238-2.444-3.9.926-1.68-1.758-4.887.058-3.384-1.765-1.28.427-2.156 3.081-7.634-3.395-1.143.17-1.113.832.244 1.832-2.665 1.555-4.826-5.392.616-2.777-1.546-2.862 1.034-1.752-1.14-3.572-1.26-1.082-2.582.61-2.845-4.292-.936-3.576 1.677-1.258.223-.927-.561-2.487-1.518-.418-.503-3.813-2.263-4.242.58-2.515-.894-2.024.631-1.871-1.18-.994.784-2.654-1.658-1.823-3.897 2.53-2.6.454-3.363 2.338-3.412-4.225-3.597-1.1 2.89-5.538-1.22-3.213 4.866-2.92-.262-.783.427-1.167-1.65-.787 1.622-4.212-1.362-2.96 2.478-.783-.036-2.07 3.244-5.671-.397-2.619 2.086-.823.487-1.88-4.817-.29-2.295-2.642.545-1.003-3.372.963.778-3.703-2.799-2.883.369-2.832-2.357-2.682-4.204-9.845-3.799-2.386-1.308-3.374-4.57-3.746 3.113-1.405-1.659-2.634 2.266-1.81-.25-2.436-5.445-11.411 7.009-31.735L247.988 33l-20.564 84.741 1.619 7.815-1.857 2.14.655 1.911zM555.059 492l7.452-99.928 2.489-33.33-48.734-4.208-.006.052-1.516-.182-1.516-.13.003-.052L386.974 339 367 472.119l155.718 18.059 11.335.985z"
	}), _react2.default.createElement("path", {
	  d: "M563 392l-8 100h.003zM367 473.01l132.215 16.01L522 491l-155-18zM387.003 339l-.003.015L511.882 354l.118-1.218zM517.988 354.24l.008-.068L516 354zM387 339l-20 133zM367 473.016V473zM387 339.02l.004-.02zM514 354.068l1.992.172-1.984-.24zM563.724 388.874L566 357.561 517.117 352l-.117 1.255 48.997 4.343L563.494 392l.227-3.126z"
	}), _react2.default.createElement("path", {
	  d: "M563.296 389l-.296 3 .3-3zM514 353.598l1.44.234 1.447.168.113-1.566-2.887-.434zM775.332 641.636l-.192-19.233-2.666-.833-6.347 1.246-2.48-3.205-11.588-3.895-2.974-3.697-5.826-2.95-2.977 3.084-7.06-.58-1.276-1.936-3.157 1.118-.317 2.336-5.814-1.986-4.875 1.968-1.886 2.585-2.303-.127-1.25 3.6-4.006-4.66-7.78-2.297-2.4-2.43-5.775 1.604.272.52-4.093 5.458-3.522-4.466.128-1.795-5.762 2.224-1.417-3.13-3.415-.209-.333-2.725-6.645 4.086-4.141-1.999.363-3.15-3.434-1.234-.357-3.876-5.387-.021-3.65 2.88-4.108-3.713-3.906.462-6.536-3.035-6.542-.03-.832-5.223-2.474-2.624-1.28 2.208-4.466-1.619-2.956 1.124-6.795-6.88-4.476-.362 3.528-66.69-65.864-4.314-13.538-1.103v.01l-1.392-.122-13.185 154.538L412 655.711l.689 3.36 7.078 5.168 2.943 7.197 6.314 3.77 3.958 7.29 24.068 23.044 4.952 27.894 6.566 10.512 21.411 19.327 10.893 2.987 16.67-25.653 7.243-2.072 6.189 2.069 24.775.908 22.03 26.05 9.178 25.666 8.528 10.283 4.236 10.123 9.409 7.017 7.23 27.184 8.76 14.166 8.596 6.216 8.395 1.333 7.864 4.834 15.445 1.665 10.254 5.213 6.676.738-.53-.431-3.389-10.357-.84-1.078-3.703-21.366 2.788-1.778.207-5.28-.07-.106-3.397-.996-2.505-1.635 1.307-4.174 5.878-.152 1.228 1.255 1.024-.635 1.194-10.198-3.778-6.921 9.394-1.552 1.95-3.503-3.245.802.536-5.526 6.676-3.673 1.624.31 2.474-2.737.808-2.148 1.602-1.878 5.729-.361 1.191-.65.153-.906-3.03-2.542.059-3.698 1.758-3.165 4.14 1.838.004-.158 1.581-2.461 2.913 1.051 1.298 2.254.463-.224.863-2.394 3.169-1.942 1.106 5.24 7.648-2.445 2.778.49 13.38-7.404 4.388-10.414.67-17.894 2.42-2.327 2.105-1.072 3.065.249.4 6.367 4.792.25-.82 1.792 12.396-5.578 6.435-.289-1.828-2.175 3.714-3.52 1.685-3.807 1.831-2.151.564-2.112-.472-4.177-1.502-2.558 1.743-3.791-1.103-3.394 4.93-9.457-.336-2.621.966-1.34-1.517-2.625 1.688-.963-.801-1.218.444-2.31-1.943-.427.444-.53-2.7-4.629.76-1.726-2.87-3.584.538-1.118-2.93-2.455.575-4.32-.68-2.202-6.163-7.316zM865.27 317.041l6.227 4.222 1.14 5.214-1.201 6.87-2.785 2.648-.976 5.83-9.1 5.413-8.275 1.937-.994 4.276 3.66 4.003.548 5.774-3.548 4.935-1.146 6.11-6.436 3.587 1.121 5.746-2.696 1.57-.809 7.501 3.937 12.722 7.519 6.496 1.535 2.6 7.102 4.874 3.019 11.359 1.416 2.046.444.034 3.107-3.128 5.765 1.649 4.776 3.27-.386 2.576-1.453 2.697.477 2.997-4.436 9.892.502 3.486 8.29 7.435 3.05.483 12.164 9.496.16 4.532 2.78 5.293-1.639 4.425.84.44 2.194 5.649 2.748-1.537.94 1.425 5.378-6.369 12.87 4.647 1.319-1.516-2.432-3.945.711-5.217 10-3.715-2.013-5.156 1.973-4.164-3.512-.92 3.05-1.491-2.66-2.053 3.693-.9-.577-4.582.04-.028-1.357-.376 3.676-2.846-1.493-2.505 1.998-4.049 2.264.14 1.91-5.454 2.274-1.227-.487-1.546 3.524-6.727-1.414-3.893.338-2.633-4.165-5.47 1.973-3.68-1.368-3.57 2.556-2.684.125-.13-6.302-79.861-8.683-18.914-.38-5.054-65.623 3.99 2.152 1.495zM1019.137 412.308l.561-.504.03.018 3.594 2.21 4.223-1.796 5.188 3.624 2.873 5.916 8.76.68 3.929 3.63.838.124.491-1.293 3.883-1.76 6.132 3.152 2.824-.909 2.677-3.802 4.956-2.147 2.783 6.094 3.337.891 3.316 3.564 4.862-1.371.585-4.693 2.008-1.088-1.61-4.796 4.115-10.048 5.21.426.35 1.676.605-.73-1.555-3.576 1.878-1.15-.347-1.997 1.827-4.325 2.933-.973 2.897-5.994 3.313 2.35 2.34-1.568 7.406-8.514.44-2.416-1.344-1.61 1.55-3.91-.66-2.68 1.422-.483-.247-4.89 2.113-7.804-1.055-2.733.356-2.198-2.677-4.096 1.498-2.546.036-.015L1120 347.2l-6.472-42.2-4.561 1.468-22.963 17.713-7.669 1.069-8.296 4.02-9.804-.3-1.193-1.24-2.885.47-3.096-.664-3.419-2.34-6.572-1.62-33.07 3.815z"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 1423 893"
	  }, props), _ref);
	};
	
	exports.default = __webpack_require__.p + "static/states.260832e7.svg";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DownloadsModule = __webpack_require__(856);
	
	var _DownloadsModule2 = _interopRequireDefault(_DownloadsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  Components
	var Downloads = function Downloads(props) {
	  return _react2.default.createElement(
	    'ul',
	    { className: _DownloadsModule2.default.downloads__list },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Download the 2020 State Scorecard as a PDF'
	        )
	      ),
	      _react2.default.createElement(_Button2.default, { href: (0, _gatsbyLink.withPrefix)('/files/Radley_State_Scorecard_2020.pdf'), text: 'Download PDF' })
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Learn more about your state\u2019s performance through our Data Center'
	        )
	      ),
	      _react2.default.createElement(_Button2.default, { href: 'http://datacenter.commonwealthfund.org', text: 'Go to the Data Center' })
	    )
	  );
	};
	
	//  Styles
	exports.default = Downloads;
	module.exports = exports['default'];

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"downloads__list":"src-components-Downloads----Downloads-module---downloads__list---1h_EC"};

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeList = __webpack_require__(66);
	
	var _ThemeList2 = _interopRequireDefault(_ThemeList);
	
	var _states = __webpack_require__(597);
	
	var _states2 = _interopRequireDefault(_states);
	
	var _HomeIntroModule = __webpack_require__(860);
	
	var _HomeIntroModule2 = _interopRequireDefault(_HomeIntroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeIntro = function HomeIntro(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: _HomeIntroModule2.default.home__intro },
	    _react2.default.createElement(
	      'div',
	      { className: _HomeIntroModule2.default.home__intro__title },
	      _react2.default.createElement(
	        'div',
	        { className: _HomeIntroModule2.default.home__intro__title__content },
	        _react2.default.createElement(
	          'h1',
	          { className: _HomeIntroModule2.default.site__title },
	          _react2.default.createElement(
	            'strong',
	            null,
	            data.site.siteMetadata.year
	          ),
	          _react2.default.createElement('br', null),
	          data.site.siteMetadata.subtitle
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A state-by-state report measuring access to care, quality of care, health outcomes, and health disparities across the United States'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _HomeIntroModule2.default.authors },
	          'by David C. Radley, Sara R. Collins, and Jesse C. Baumgartner'
	        )
	      ),
	      _react2.default.createElement(_states.ReactComponent, { className: _HomeIntroModule2.default.home__intro__map })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _HomeIntroModule2.default.home__intro__themes },
	      _react2.default.createElement(
	        'div',
	        { className: _HomeIntroModule2.default.home__intro__themes__content },
	        _react2.default.createElement(
	          'h3',
	          { className: _HomeIntroModule2.default.home__intro__themes__title },
	          'Browse by Highlight or State'
	        ),
	        _react2.default.createElement(_ThemeList2.default, { themes: data.allThemesJson.edges }),
	        _react2.default.createElement(
	          'select',
	          { onChange: function onChange(e) {
	              return (0, _gatsbyLink.navigateTo)(e.target.value);
	            }, className: _HomeIntroModule2.default.state__header__select },
	          _react2.default.createElement(
	            'option',
	            null,
	            'Select a State'
	          ),
	          data.allStatesJson.edges.map(function (node) {
	            return _react2.default.createElement(
	              'option',
	              { key: node.node.id, value: (0, _gatsbyLink.withPrefix)('/state/' + node.node.url) },
	              node.node.title
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	//  Styles
	
	
	//  Components
	exports.default = HomeIntro;
	module.exports = exports['default'];

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"home__intro":"src-components-HomeIntro----HomeIntro-module---home__intro---sYVKu","home__intro__title":"src-components-HomeIntro----HomeIntro-module---home__intro__title---3u4Xw","home__intro__title__content":"src-components-HomeIntro----HomeIntro-module---home__intro__title__content---3B0nq","home__intro__map":"src-components-HomeIntro----HomeIntro-module---home__intro__map---vLDXH","site__title":"src-components-HomeIntro----HomeIntro-module---site__title---1N4nb","home__intro__themes":"src-components-HomeIntro----HomeIntro-module---home__intro__themes---35s5M","home__intro__themes__content":"src-components-HomeIntro----HomeIntro-module---home__intro__themes__content---w_ri3","home__intro__themes__title":"src-components-HomeIntro----HomeIntro-module---home__intro__themes__title---dklBv","state__header__select":"src-components-HomeIntro----HomeIntro-module---state__header__select---mk0ly","authors":"src-components-HomeIntro----HomeIntro-module---authors---3E2F4"};

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(392);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HomeTextCollapseModule = __webpack_require__(861);
	
	var _HomeTextCollapseModule2 = _interopRequireDefault(_HomeTextCollapseModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeTextCollapse = function (_Component) {
	  _inherits(HomeTextCollapse, _Component);
	
	  function HomeTextCollapse(props) {
	    _classCallCheck(this, HomeTextCollapse);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.toggleAction = function () {
	      _this.setState(function (state) {
	        return { collapse: !state.collapse };
	      });
	    };
	
	    var collapse = _this.props.options.collapse;
	
	    _this.state = {
	      collapse: collapse ? collapse : true
	    };
	    return _this;
	  }
	
	  HomeTextCollapse.prototype.renderHelperText = function renderHelperText() {
	    var _props$options = this.props.options,
	        collapseText = _props$options.collapseText,
	        expandText = _props$options.expandText,
	        textStyle = _props$options.textStyle;
	    var collapse = this.state.collapse;
	
	
	    if (collapse) {
	      return _react2.default.createElement(
	        'div',
	        { className: _HomeTextCollapseModule2.default.collapse, style: _extends({}, textStyle) },
	        collapseText
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _HomeTextCollapseModule2.default.expand, style: _extends({}, textStyle) },
	      expandText
	    );
	  };
	
	  HomeTextCollapse.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        _props$options2 = _props.options,
	        minHeight = _props$options2.minHeight,
	        maxHeight = _props$options2.maxHeight,
	        children = _props.children;
	    var collapse = this.state.collapse;
	
	    return _react2.default.createElement(
	      _reactMotion.Motion,
	      {
	        defaultStyle: { h: 0 },
	        style: { h: (0, _reactMotion.spring)(collapse ? minHeight : maxHeight) }
	      },
	      function (_ref) {
	        var h = _ref.h;
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'block',
	                overflow: collapse ? 'hidden' : 'auto',
	                height: '' + h + 'px'
	              }
	            },
	            children
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _HomeTextCollapseModule2.default.collapse__toggle_wrapper, onClick: _this2.toggleAction },
	            _this2.renderHelperText()
	          )
	        );
	      }
	    );
	  };
	
	  return HomeTextCollapse;
	}(_react.Component);
	
	HomeTextCollapse.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  options: _propTypes2.default.object.isRequired
	};
	exports.default = HomeTextCollapse;
	module.exports = exports['default'];

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"collapse":"src-components-HomeTextCollapse----HomeTextCollapse-module---collapse---3lN2_","expand":"src-components-HomeTextCollapse----HomeTextCollapse-module---expand---2t5Ks","collapse__toggle_wrapper":"src-components-HomeTextCollapse----HomeTextCollapse-module---collapse__toggle_wrapper---JYHsp"};

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeLink = __webpack_require__(406);
	
	var _ThemeLink2 = _interopRequireDefault(_ThemeLink);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _KeyThemesModule = __webpack_require__(862);
	
	var _KeyThemesModule2 = _interopRequireDefault(_KeyThemesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KeyThemes = function KeyThemes(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _KeyThemesModule2.default.key__themes },
	      _react2.default.createElement(
	        'h2',
	        { className: _KeyThemesModule2.default.key__themes__title },
	        'Highlights'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: _KeyThemesModule2.default.key__themes__list },
	        props.data.allThemesJson.edges.map(function (node) {
	          return _react2.default.createElement(
	            'li',
	            { key: node.node.theme_id },
	            _react2.default.createElement(_ThemeLink2.default, {
	              node: node.node,
	              className: 'theme__link__large' })
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _KeyThemesModule2.default.key__themes__conclusion },
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/conclusion' },
	          'Conclusion'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _KeyThemesModule2.default.key__themes__conclusion__content },
	        _react2.default.createElement(
	          'p',
	          null,
	          'The 2020 Scorecard offers the latest available federal data on the state of the U.S. health system before it headed into the most severe public health crisis and economic collapse in modern times. It also highlights health system weaknesses that have left the U.S. far less prepared than other high-income countries to cope with public health threats like COVID-19. These weaknesses include:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'a health care delivery system that is highly unequal in its care of people of color and those with low and moderate incomes.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'an insurance system that still leaves millions without coverage.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'exorbitant commercial insurance prices that fuel growth in health spending and expose people to high premiums and deductibles, even as many make wage concessions to keep their employer benefits.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'an inadequate primary care system.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'declining life expectancy.'
	          )
	        ),
	        _react2.default.createElement(_Button2.default, {
	          to: '/conclusion',
	          text: 'Keep Reading',
	          className: 'button__primary__reversed'
	        })
	      )
	    )
	  );
	};
	
	//  Styles
	
	
	//  Components
	exports.default = KeyThemes;
	module.exports = exports['default'];

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"key__themes":"src-components-KeyThemes----KeyThemes-module---key__themes---3gCLV","key__themes__conclusion":"src-components-KeyThemes----KeyThemes-module---key__themes__conclusion---1gE1x","key__themes__title":"src-components-KeyThemes----KeyThemes-module---key__themes__title---3Hmsn","key__themes__list":"src-components-KeyThemes----KeyThemes-module---key__themes__list---7jn0n","key__themes__conclusion__content":"src-components-KeyThemes----KeyThemes-module---key__themes__conclusion__content---1mjD0"};

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeLinkModule = __webpack_require__(868);
	
	var _ThemeLinkModule2 = _interopRequireDefault(_ThemeLinkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemeLink = function ThemeLink(props) {
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: [_ThemeLinkModule2.default.theme__link, _ThemeLinkModule2.default[props.className]].join(" "), to: props.node.path },
	    _react2.default.createElement(
	      'h3',
	      { className: _ThemeLinkModule2.default.theme__link__title },
	      props.node.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _ThemeLinkModule2.default.theme__link__statistic },
	      _react2.default.createElement(
	        'h2',
	        null,
	        props.node.stat.prefix ? _react2.default.createElement(
	          'sup',
	          null,
	          props.node.stat.prefix
	        ) : "",
	        _react2.default.createElement(
	          'strong',
	          null,
	          props.node.stat.number
	        ),
	        props.node.stat.suffix
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        props.node.stat.text
	      )
	    )
	  );
	};
	
	//  Styles
	exports.default = ThemeLink;
	module.exports = exports['default'];

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"theme__link":"src-components-ThemeLink----ThemeLink-module---theme__link---fJ4md","theme__link__title":"src-components-ThemeLink----ThemeLink-module---theme__link__title---2Kt0Z","theme__link__statistic":"src-components-ThemeLink----ThemeLink-module---theme__link__statistic---29let","theme__link__large":"src-components-ThemeLink----ThemeLink-module---theme__link__large---2QjR5"};

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _states = __webpack_require__(59);
	
	var _states2 = _interopRequireDefault(_states);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StateChangeSummary = function StateChangeSummary(_ref) {
	  var index = _ref.index,
	      state = _ref.state,
	      summary = _ref.summary;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: 'cmwf--state-change-summary' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'cmwf--state-change-summary-link', to: '/state/' + _states2.default[state].toLowerCase().replace(/ /g, "-") },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'cmwf--state-change-summary--top' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cmwf-state-img' },
	          _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/states/' + state + '.png'), alt: '' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cmwf-state-abbr cmwf--state-abbr-' + state },
	          state
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'cmwf--index' },
	        _react2.default.createElement(
	          'span',
	          null,
	          index
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'cmwf--state-change-summary--bottom' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'cmwf--state-name' },
	          _states2.default[state]
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'cmwf--summary' },
	          summary
	        )
	      )
	    )
	  );
	};
	
	StateChangeSummary.propTypes = {
	  index: _propTypes2.default.number.isRequired,
	  state: _propTypes2.default.string.isRequired,
	  summary: _propTypes2.default.string.isRequired
	};
	
	exports.default = StateChangeSummary;
	module.exports = exports['default'];

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopBottomToggleOption = function TopBottomToggleOption(_ref) {
	  var value = _ref.value,
	      label = _ref.label,
	      selected = _ref.selected,
	      changeHandler = _ref.changeHandler;
	  return _react2.default.createElement(
	    'span',
	    { className: 'top-bottom__option cmwf--radio-option' },
	    _react2.default.createElement('input', {
	      className: 'top-bottom__option__input',
	      type: 'radio',
	      id: 'cmwf--' + value,
	      checked: selected,
	      onChange: function onChange() {
	        return changeHandler(value);
	      }
	    }),
	    _react2.default.createElement(
	      'label',
	      { className: 'top-bottom__option__label', htmlFor: 'cmwf--' + value },
	      label
	    )
	  );
	};
	
	TopBottomToggleOption.propTypes = {
	  value: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.string.isRequired,
	  selected: _propTypes2.default.bool.isRequired,
	  changeHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = TopBottomToggleOption;
	module.exports = exports['default'];

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _topBottomToggleOption = __webpack_require__(572);
	
	var _topBottomToggleOption2 = _interopRequireDefault(_topBottomToggleOption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopBottomToggle = function TopBottomToggle(_ref) {
	  var value = _ref.value,
	      changeHandler = _ref.changeHandler;
	  return _react2.default.createElement(
	    'div',
	    { className: 'top-bottom__options' },
	    _react2.default.createElement(_topBottomToggleOption2.default, {
	      value: 'top-rank',
	      label: 'Top 5 in Rank',
	      selected: value === 'top-rank',
	      changeHandler: changeHandler
	    }),
	    _react2.default.createElement(_topBottomToggleOption2.default, {
	      value: 'bottom-rank',
	      label: 'Bottom 5 in Rank',
	      selected: value === 'bottom-rank',
	      changeHandler: changeHandler
	    }),
	    _react2.default.createElement(_topBottomToggleOption2.default, {
	      value: 'top-improve',
	      label: 'Top 5 in Improvement',
	      selected: value === 'top-improve',
	      changeHandler: changeHandler
	    }),
	    _react2.default.createElement(_topBottomToggleOption2.default, {
	      value: 'bottom-improve',
	      label: 'Bottom 5 in Improvement',
	      selected: value === 'bottom-improve',
	      changeHandler: changeHandler
	    })
	  );
	};
	
	TopBottomToggle.propTypes = {
	  value: _propTypes2.default.string.isRequired,
	  changeHandler: _propTypes2.default.func.isRequired
	};
	
	exports.default = TopBottomToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loading = __webpack_require__(67);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _request = __webpack_require__(68);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _stateChangeSummary = __webpack_require__(571);
	
	var _stateChangeSummary2 = _interopRequireDefault(_stateChangeSummary);
	
	var _statesToArray = __webpack_require__(139);
	
	var _statesToArray2 = _interopRequireDefault(_statesToArray);
	
	var _topBottomToggle = __webpack_require__(573);
	
	var _topBottomToggle2 = _interopRequireDefault(_topBottomToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopBottom = function (_React$Component) {
	  _inherits(TopBottom, _React$Component);
	
	  function TopBottom(props) {
	    _classCallCheck(this, TopBottom);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      data: {},
	      display: 'top-rank'
	    };
	    _this.onDisplayChange = _this.onDisplayChange.bind(_this);
	    return _this;
	  }
	
	  TopBottom.prototype.componentWillMount = function componentWillMount() {
	    var data = this.state.data;
	    /* istanbul ignore next */
	
	    if (!data.ranking) {
	      this.loadJSON('ranking');
	    }
	  };
	
	  TopBottom.prototype.onDisplayChange = function onDisplayChange(value) {
	    this.setState({ display: value });
	  };
	
	  TopBottom.prototype.loadJSON = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
	      var newData;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _request2.default)('/data/' + name + '.json');
	
	            case 2:
	              newData = _context.sent;
	
	              this.setState(function (prevState) {
	                var _extends2;
	
	                return {
	                  data: _extends({}, prevState.data, (_extends2 = {}, _extends2[name] = newData, _extends2))
	                };
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function loadJSON(_x) {
	      return _ref.apply(this, arguments);
	    }
	
	    return loadJSON;
	  }();
	
	  TopBottom.prototype.statesByRank = function statesByRank() {
	    var data = this.state.data;
	
	    return (0, _statesToArray2.default)(data.ranking).sort(function (a, b) {
	      return parseInt(a.rank, 10) > parseInt(b.rank, 10) ? 1 : -1;
	    });
	  };
	
	  TopBottom.prototype.statesByIndicatorImprovement = function statesByIndicatorImprovement() {
	    var data = this.state.data;
	
	    return (0, _statesToArray2.default)(data.ranking).sort(function (a, b) {
	      var aInd = parseInt(a.ind, 10);
	      var bInd = parseInt(b.ind, 10);
	      return aInd < bInd || aInd === bInd && a.state > b.state ? 1 : -1;
	    });
	  };
	
	  TopBottom.prototype.displayStates = function displayStates(display) {
	    var states = void 0;
	    if (['top-rank', 'bottom-rank'].includes(display)) {
	      states = this.statesByRank();
	      if (display === 'top-rank') {
	        // This is a hack on which removes Vermont from the top 5, due to a tie with Connecticut. There 
	        // was no logic on which to base this decision on.
	        states = states.filter(function (value) {
	          return value['state'] !== 'VT';
	        }).slice(0, 5);
	      } else {
	        states = states.reverse().slice(0, 5).reverse();
	      }
	      return states.map(function (state, index) {
	        var change = parseInt(state.base_rank, 10) - parseInt(state.rank, 10);
	        var roseFell = change > 0 ? 'Rose' : 'Fell';
	        var places = Math.abs(change) === 1 ? 'place' : 'places';
	        var summary = change === 0 ? 'No change in ranking.' : roseFell + ' ' + Math.abs(change) + ' ' + places + ' in ranking.';
	        return _react2.default.createElement(_stateChangeSummary2.default, {
	          key: state.state,
	          index: display === 'top-rank' ? index + 1 : index + 47,
	          state: state.state,
	          summary: summary
	        });
	      });
	    }
	    states = this.statesByIndicatorImprovement();
	    if (display === 'top-improve') {
	      states = states.slice(0, 5);
	    } else {
	      states = states.reverse().slice(0, 5).reverse();
	    }
	    return states.map(function (state, index) {
	      var indicators = state.ind === 1 ? 'indicator' : 'indicators';
	      var summary = 'Improved on ' + state.ind + ' ' + indicators + '.';
	      return _react2.default.createElement(_stateChangeSummary2.default, {
	        index: display === 'top-improve' ? index + 1 : index + 47,
	        key: state.state,
	        state: state.state,
	        summary: summary
	      });
	    });
	  };
	
	  TopBottom.prototype.render = function render() {
	    var _state = this.state,
	        data = _state.data,
	        display = _state.display;
	
	    if (!data.ranking) {
	      return _react2.default.createElement(_loading2.default, { message: 'Loading data...' });
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'top-bottom' },
	      _react2.default.createElement(_topBottomToggle2.default, { value: display, changeHandler: this.onDisplayChange }),
	      _react2.default.createElement(
	        'div',
	        { className: 'cmwf--state-change-summaries' },
	        this.displayStates(display)
	      )
	    );
	  };
	
	  return TopBottom;
	}(_react2.default.Component);
	
	exports.default = TopBottom;
	module.exports = exports['default'];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(130);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(140);
	
	var _HomeTextCollapse = __webpack_require__(559);
	
	var _HomeTextCollapse2 = _interopRequireDefault(_HomeTextCollapse);
	
	var _HomeIntro = __webpack_require__(558);
	
	var _HomeIntro2 = _interopRequireDefault(_HomeIntro);
	
	var _PageHeader = __webpack_require__(109);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _ThemeLink = __webpack_require__(406);
	
	var _ThemeLink2 = _interopRequireDefault(_ThemeLink);
	
	var _KeyThemes = __webpack_require__(560);
	
	var _KeyThemes2 = _interopRequireDefault(_KeyThemes);
	
	var _Button = __webpack_require__(31);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Downloads = __webpack_require__(554);
	
	var _Downloads2 = _interopRequireDefault(_Downloads);
	
	var _topBottom = __webpack_require__(576);
	
	var _topBottom2 = _interopRequireDefault(_topBottom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEXT_COLLAPSE_OPTIONS = {
	  collapse: true, // default state when component rendered
	  collapseText: 'Keep Reading', // text to show when collapsed
	  expandText: 'View Less', // text to show when expanded
	  minHeight: 0, // component height when closed
	  maxHeight: 500, // expanded to
	  textStyle: { // pass the css for the collapseText and expandText here
	    color: '#f47920',
	    fontSize: '20px'
	  }
	};
	
	//  Components
	
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_HomeIntro2.default, { data: data }),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'section section__full section__pull_top section__exhibit section__exhibit__padded' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'title__block' },
	        'The Top & Bottom'
	      ),
	      _react2.default.createElement(_topBottom2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'section__centered' },
	        _react2.default.createElement(_Button2.default, {
	          to: '/rankings',
	          text: 'Check Out All States'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row section__row__2_up' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__content__narrow' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'The COVID-19 pandemic has disrupted health care around the globe. In the United States, where it has claimed the lives of more than 185,000 people, health systems in every state have been stretched \u2014 in some cases severely.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__content__wide' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'The novel coronavirus has exposed and exacerbated existing weaknesses that have long been the focus of the ',
	            _react2.default.createElement(
	              'em',
	              null,
	              'Commonwealth Fund\u2019s Scorecard on State Health System Performance'
	            ),
	            '. First, because most Americans get their health insurance through an employer, recent job losses have widened coverage gaps that existed prior to the crisis. The Urban Institute projects that 10 million people will lose their employer coverage by year\u2019s end, leaving 3.5 million uninsured.',
	            _react2.default.createElement(
	              'sup',
	              { className: 'note__link' },
	              _react2.default.createElement(
	                'a',
	                { href: '#1' },
	                '1'
	              )
	            ),
	            ' The loss of job-based coverage has also brought into sharp relief the impact of states\u2019 decisions not to expand Medicaid eligibility for low-income residents; 12 states have yet to expand their programs as allowed under the Affordable Care Act (ACA).',
	            _react2.default.createElement(
	              'sup',
	              { className: 'note__link' },
	              _react2.default.createElement(
	                'a',
	                { href: '#2' },
	                '2'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _HomeTextCollapse2.default,
	            { options: TEXT_COLLAPSE_OPTIONS },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Second, Black, Latino, and other communities of color, already more likely to be uninsured, have been disproportionally burdened by COVID-19 and the related economic fallout. Systemic racial and ethnic inequities in health care access and quality have contributed to higher hospitalization and mortality rates from COVID-19 among Black, Latino, American Indian, and Alaska Native individuals, among others.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Third, the pandemic has exposed the vulnerability of health providers reliant on the fee-for-service payment system. Many are facing steep revenue losses and the threat of closure as social-distancing restrictions, fear, and a nose-diving economy have driven down both the supply and demand for routine and elective care.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#3' },
	                  '3'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Finally, the country faces many unanswered questions on the extent to which COVID-19 and the ongoing economic fallout will contribute to suicides, deaths from alcohol and substance use, and further erosion of Americans\u2019 life expectancy.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_KeyThemes2.default, { data: data }),
	    _react2.default.createElement(_Downloads2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '1', style: { counterReset: 'item 0' }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '1' },
	              'Jessica Banthin et al., ',
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'https://www.urban.org/research/publication/changes-health-insurance-coverage-due-covid-19-recession' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Changes in Health Insurance Coverage Due to the COVID-19 Recession: Preliminary Estimates Using Microsimulation'
	                  )
	                )
	              ),
	              ' (Urban Institute, July 2020).'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '2' },
	              'Voters in Oklahoma and Missouri passed Medicaid expansion by ballot in June and August of 2020; the states are expected to implement expansion by the summer of 2021.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '3' },
	              'Ateev Mehrotra et al., ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.commonwealthfund.org/publications/2020/aug/impact-covid-19-pandemic-outpatient-visits-changing-patterns-care-newest' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'The Impact of the COVID-19 Pandemic on Outpatient Visits: Changing Patterns of Care in the Newest COVID-19 Hot Spots'
	                  )
	                )
	              ),
	              ' (Commonwealth Fund, Aug. 2020).'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-c9ade37e54359a77f60b.js